import React from 'react'

const Success = () => {
  return (
    <div>
      <center><h1>Заявка принята</h1></center>
      <p style={{
        marginLeft: '15%',
        marginRight: '15%',
      }}>* Наш специалист свяжется с вами в ближайшее время для подтверждения записи на техническое обслуживание. Мы предоставляем полный спектр услуг: диагностика, ремонт, ТО, замена запчастей и другие работы с автомобилями любых марок. Стоимость услуг зависит от сложности работ и используемых запчастей. Все работы выполняются квалифицированными мастерами с использованием современного оборудования. Сервисный центр работает ежедневно с 9:00 до 21:00. Для записи на обслуживание необходимо заполнить форму на сайте.</p>
    </div>
  )
}

export default Success